// extracted by mini-css-extract-plugin
module.exports = {"labelClass":"uY","inputClass":"uZ"};